import styled from 'styled-components'
import { px2rem } from '../../../../../theme/Global'
import { DetailsHeading } from '../TopicsDetailComponent/styles'

export const ProductSummaryContainer = styled.div`
  display: 'block';
  ${DetailsHeading} {
    margin-top: 1rem;
  }
`
export const DetailsSummaryItem = styled.div`
  width: 100%;
  & h2 {
    margin-bottom: ${px2rem(4)}rem;
  }
`
